import { render, staticRenderFns } from "./InvitationDetail.vue?vue&type=template&id=3631a4d0&scoped=true"
import script from "./InvitationDetail.vue?vue&type=script&lang=js"
export * from "./InvitationDetail.vue?vue&type=script&lang=js"
import style0 from "./InvitationDetail.vue?vue&type=style&index=0&id=3631a4d0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3631a4d0",
  null
  
)

export default component.exports